import { Component, OnInit, Input, Output, ViewChild, OnDestroy, EventEmitter } from '@angular/core';
import {TaskService} from '../../services/task.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UtilsModule } from '../../utils/utils.module';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {DatePipe} from '@angular/common';
import {debounceTime, map, switchMap} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
@Component({
  selector: 'nf-pulse-card',
  templateUrl: './pulse-card.component.html',
  styleUrls: ['./pulse-card.component.css'],
  providers: [TaskService, DatePipe]
})
export class PulseCardComponent implements OnInit, OnDestroy {
  dataSubscription: Subscription = null;
  boardId = null; // 存放面板ID
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  addTaskData = {}; // 存放新增任务数据
  selectedGroup: string; // 新增任务选择组ID
  addPulseNameValue: string; // 添加行输入框绑定值
  group: any = {}; // 当前组件分组数据
  pulse: any = {}; // 当前组件行数据
  column: any = {}; // 当前组件列数据
  addTabBGColor = '#F7F7F7'; // 添加标签默认背景颜色
  defaultStatus: any = {}; // 状态下拉颜色
  taskView: string; // 面板视图类型
  personOption: Array<any> = [];  // 指派人组件下拉选项
  statusWidth = 135; // 标签组件下拉框动态宽度
  isEditVisual = true; // 标签组件下拉框按钮状态
  statusInit = []; // 存放初始状态色块
  statusTemp = []; // 存放操作过程中状态
  statusDel = []; // 存放移除掉的状态;
  addProgressValue = 0; // 存放进度条
  dropdownLabel = []; // 下拉组件选中项
  dropdownInputValue = ''; // 下拉组件输入框绑定值
  dropdownOption = []; // 下拉组件新增列表
  isDropdownOptionEdit = true; // 下拉组件选项是否可编辑
  pulseIds: Array<any> = []; // 存放选中的行ID
  instanceColumnData: any;
  selectedUserData = {};
  open = false;
  randomUserUrl: string;
  searchChange$ = new BehaviorSubject('');
  isLoading = false;

  @Input() dateColumnEnable = false;

  @Input('nfData') set changeData(data: any) {
    if (JSON.stringify(data) !== '{}') {
      this.boardData = data;
      this.boardGroupData = this.boardData.boardData.groups;
      this.boardColumnData = this.boardData.boardData.columns;
      this.boardPulseData = this.boardData.boardData.pulses;
      this.boardId = this.boardData.id;
    }
  }
  @Input('taskView') set changeView(data: string) {
    this.taskView = data;
  }
  @Input('pulseIds') set changePulse(data: any) {
    this.pulseIds = data;
  }
  @Input('nfInstanceData') set ChangeInstanceData(data: any) {
    if (data) {
      this.instanceColumnData = data.columnValues;
    }
  }
  @Output() private nfChangeData: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private message: NzMessageService,
    private utilsModule: UtilsModule,
    private http: HttpClient,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    // this.initSelectOption();
    this.initPulseData();
    this.statusInit = JSON.parse(localStorage.getItem('statusInit'));
    this.statusWidth = this.statusInit.length / 4 * 122;
  }
  ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }
  // 初始化任务字段
  initPulseData() {
    this.boardColumnData.forEach((item, index) => {
      if (item.type === 'multiple-person') {
        if (this.instanceColumnData && this.instanceColumnData[item.id]) {
          this.addTaskData[item.id] = this.instanceColumnData[item.id];
        } else {
          this.addTaskData[item.id] = {'personsAndTeams' : []};
        }
      } else if (item.type === 'status') {
        if (item) {
          this.defaultStatus[item.id] = item.labels;
        }
        this.addTaskData[item.id] = {
          'index': 0
        };
      } else if (item.type === 'date') {
        if (this.dateColumnEnable) {
          this.addTaskData[item.id] = {
            date: null,
            radioValue: 'A'
          };
        } else {
          this.addTaskData[item.id] = {
            'date': null
          };
        }
      } else if (item.type === 'date-time') {
        if (this.dateColumnEnable) {
          this.addTaskData[item.id] = {
            dateTime: null,
            radioValue: 'A'
          };
        } else {
          this.addTaskData[item.id] = {
            dateTime: null
          };
        }
      } else if (item.type === 'time-interval') {
        if (this.dateColumnEnable) {
          this.addTaskData[item.id] = {
            radioValue: 'A',
            date: [],
            n: 0,
            dayType: 'n'
          };
        } else {
          this.addTaskData[item.id] = {
            date: []
          };
        }

      } else if (item.type === 'name') {
        this.addTaskData[item.id] = this.addPulseNameValue;
      } else {
        this.addTaskData[item.id] = '';
      }
    });
    if (this.instanceColumnData && JSON.stringify(this.instanceColumnData) !== '{}') {
      for (const attr in this.addTaskData) {
        if (this.instanceColumnData.hasOwnProperty(attr)) {
          this.addTaskData[attr] = this.instanceColumnData[attr];
          if (this.addTaskData[attr] && this.addTaskData[attr].hasOwnProperty('date') && this.addTaskData[attr].hasOwnProperty('time')) {
            this.addTaskData[attr]['dateTime'] = this.addTaskData[attr]['date'] + ' ' + this.addTaskData[attr]['time'];
          }
        }
      }
    }
  }
  // 处理人员组件数据
  initMultiPerson() {
    this.boardColumnData.forEach((item) => {
      if (item.type === 'multiple-person') {
        // if (this.addTaskData[item.id] && this.addTaskData[item.id]['personsAndTeams']) {
        //   const value = [];
        //   for (const val of this.addTaskData[item.id]['personsAndTeams']) {
        //     for (const person of this.personOption) {
        //       if (val.id === person.id) {
        //         value.push(person);
        //         break;
        //       }
        //     }
        //   }
        //   this.addTaskData[item.id]['personsAndTeams'] = value;
        // }
        // if (this.addTaskData[item.id].personsAndTeams && this.addTaskData[item.id].personsAndTeams.length > 0) {
        //   this.selectedUserData[item.id] = this.addTaskData[item.id].personsAndTeams;
        // }
        this.selectedUserData[item.id] = [];
      }
      if (item.type === 'date') {
        if (this.addTaskData[item.id] && this.addTaskData[item.id]['date']) {
          this.addTaskData[item.id]['date'] = new Date(this.addTaskData[item.id]['date']);
        }
      }
    });
  }
  // 切换分组
  changeGroup(event) {
    this.selectedGroup = event;
  }
  // 切换日期列类型
  dateTypeChange(target) {
    if (target['radioValue'] === 'A') {
      target['date'] = null;
    } else {
      target['date'] = 'taskDate';
    }
  }
  dateTimeTypeChange(target) {
    if (target['radioValue'] === 'A') {
      target['dateTime'] = null;
    } else {
      target['dateTime'] = 'taskDateTime';
    }
  }
  radioChange(target) {
    if (target['radioValue'] === 'B') {
      target['n'] = 0;
      target['dayType'] = 'n';
    }
  }
  // 指派人组件-初始化选择列表
  initSelectOption() {
    this.getBoardUserData();
  }
  // 支持模糊搜索获取待选成员数据
  getBoardUserData() {
    this.randomUserUrl = this.taskService.getBoardUser(this.boardData.id);
    const getRandomNameList = (searchKey: string) =>
      this.http
        .get(`${this.randomUserUrl}`, {params: {searchKey}})
        .pipe(map((res: any) => res.users ? res.users.data : []))
        .pipe(
          map((list: any) => {
            for (const item of list) {
              item['label'] = item['name'];
            }
            return list;
          })
        );
    const optionList$: Observable<string[]> = this.searchChange$
      .asObservable()
      .pipe(debounceTime(500))
      .pipe(switchMap(getRandomNameList));
    optionList$.subscribe(data => {
      this.personOption = data;
      this.initMultiPerson();
      this.isLoading = false;
    });
  }
  // 模糊搜索
  onMemberSearch(value: string): void {
    this.isLoading = true;
    const param = {
      size: '999',
      page: '1',
      searchKey: value
    };
    this.taskService.getBoardUer(this.boardData.id, param).subscribe((res: any) => {
      if (res) {
        this.personOption = res.users ? res.users.data : [];
        this.initMultiPerson();
        this.isLoading = false;
      }
    });
    // this.searchChange$.next(value);
  }
  // 更换状态标签
  clickStatus() {
    this.isEditVisual = true;
    this.statusWidth = this.statusInit.length / 4 * 122;
  }
  // 计算标签组件框宽度
  getStatusWidth(label) {
    const len = label.length;
    const width = 134;
    if (len > 4) {
      this.statusWidth = Number.isInteger(len / 4) ? len / 4 * width : Math.ceil(len / 4) * width;
    } else {
      this.statusWidth = width;
    }
    return {'width': this.statusWidth + 'px'};
  }
  // 切换选中状态颜色
  changeStatus(columnId, item) {
    let count = 0;
    let checked = 0;
    if (columnId) {
      for (const key in this.addTaskData) {
        if (this.addTaskData.hasOwnProperty(key)) {
          if (key === columnId) {
            this.addTaskData[key] = item;
          }
        }
      }
    }
    // 进度条赋值
    this.boardColumnData.forEach((list, index) => {
      if (list.type === 'status') {
        count = count + 1;
        if (this.addTaskData[list.id] && this.addTaskData[list.id].index === 2) {
          checked = checked + 1;
        }
      }
    });
    if (checked) {
      this.addProgressValue = parseInt(((checked / count) * 100).toString(), 0);
    } else {
      this.addProgressValue = 0;
    }
  }
  // 鼠标移入移出添加标签背景变色
  mouseEnterStatus(color) {
    this.addTabBGColor = color;
  }
  mouseLeaveStatus() {
    this.addTabBGColor = '#F7F7F7';
  }
  // 标签组件切换到编辑状态
  editStatus(column, pulse) {
    this.isEditVisual = !this.isEditVisual;
    this.getStatusWidth(this.statusInit);
    // 处理编辑状态选项
    this.statusTemp = column.labels;
    // 状态标签列表增加已用标签
    const tempList = [];
    this.boardPulseData.forEach((list, i) => {
      for (let k = 0; k < this.boardColumnData.length; k++) {
        if (this.boardColumnData[k].type === 'status') {
          tempList.push(list.columnValues[this.boardColumnData[k].id].index);
        }
      }
    });
    this.statusTemp.map((item, i) => {
      item.use = false;
      if (item.index === 0) {
        this.statusTemp.splice(i, 1);
      }
    });
    tempList.forEach((item, index) => {
      for (let i = 0; i < this.statusTemp.length; i++) {
        if (item === this.statusTemp[i].index) {
          this.statusTemp[i].use = true;
        }
      }
    });
    // 状态标签未选列表
    const arr = this.statusInit.filter(obj => !this.statusTemp.some(obj1 => obj1.index === obj.index));
    this.statusDel = arr;
  }
  // 标签组件提交编辑
  submitEditStatus(columnId, boardId) {
    const param = {
      'labels': this.statusTemp
    };
    this.defaultStatus[columnId] = this.statusTemp;
    this.taskService.doAddStatusLabel(boardId, columnId, param).subscribe((res: any) => {
      this.boardColumnData.forEach((item, index) => {
        if (item.id === columnId) {
          item.labels = this.statusTemp;
        }
        let count = 0;
        if (item.type === 'status') {
          for (let i = 0; i < item.labels.length; i++) {
            if (item.labels[i].index === 0) {
              count = count + 1;
            }
          }
          if (count === 0) {
            if (item.type === 'status') {
              const o = {
                'color': 'rgb(196, 196, 196)',
                'index': 0,
                'label': ''
              };
              item.labels.push(o);
            }
          }
        }
      });
      this.isEditVisual = !this.isEditVisual;
    });
  }
  // 删除状态标签
  removeStatusTag(id) {
    this.statusTemp = this.statusTemp.filter(d => d.index !== id);
    this.statusInit.forEach((item, index) => {
      if (id === item.index) {
        this.statusDel.push(item);
      }
    });
  }
  // 添加状态标签
  addStatusTag() {
    const arr = this.statusInit.filter(obj => !this.statusTemp.some(obj1 => obj1.index === obj.index));
    if (arr.length > 0) {
      this.statusTemp = [
        ...this.statusTemp,
        {
          index: arr[0].index,
          label: '',
          color: arr[0].color
        }
      ];
      this.statusDel = this.statusDel.filter(d => d.color !== arr[0].color);
    }
  }
  // 添加自定义颜色标签
  addCustomTag(index) {
    const arr = this.statusInit.filter(obj => !this.statusTemp.some(obj1 => obj1.index === obj.index));
    if (arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        if (index === arr[i].index) {
          this.statusTemp = [
            ...this.statusTemp,
            {
              index: arr[i].index,
              label: '',
              color: arr[i].color
            }
          ];
          this.statusDel = this.statusDel.filter(d => d.index !== arr[i].index);
        }
      }
    }
    this.addTabBGColor = '#F7F7F7';
  }
  // 打开popover框还原编辑状态
  openDropdownPopover(column?: any) {
    this.isDropdownOptionEdit = true;
    this.handleDropdownOptionList(column);
  }
  // 下拉组件 关闭选中标签
  handleDropdownClose(removedLabel, column): void {
    this.addTaskData[column.id].ids.splice(this.addTaskData[column.id].ids.findIndex(v => v === removedLabel.id), 1);
    this.dropdownOption = [removedLabel, ...this.dropdownOption];
    // this.patchDropdownPulseData();
  }
  // 下拉组件 限制标签文字长度
  sliceTagName(tag: string): string {
    const isLongTag = tag.length > 20;
    return isLongTag ? `${tag.slice(0, 20)}...` : tag;
  }
  // 下拉组件 处理新增标签
  handleDropdownInputConfirm(value): void {
    const column = value;
    const maxId = this.getDropdownOptionId(column.settings.labels) + 1;
    if (this.dropdownInputValue) {
      const newOption = {
        'id': maxId,
        'name': this.dropdownInputValue
      };
      this.dropdownOption = [newOption, ...this.dropdownOption];
      column.settings.labels = [newOption, ...column.settings.labels];
      this.patchDropdownColumnData(column.id, column);
    }
    this.dropdownInputValue = '';
  }
  selectedUserDataChange(columnId) {
    this.addTaskData[columnId] = {
      personsAndTeams: this.selectedUserData[columnId]
    };
  }
  // 下拉组件 新增选项触发选中
  handleDropdownOption(column, option) {
    if (!this.addTaskData[column.id]) {
      this.addTaskData[column.id] = {
        'ids': []
      };
    }
    this.dropdownOption = this.dropdownOption.filter(label => label.id !== option.id);
    this.addTaskData[column.id].ids.push(option.id);
    this.addTaskData[column.id].ids = Array.from(new Set(this.addTaskData[column.id].ids));
    // 选中后暂不触发请求
    // this.patchDropdownPulseData(column);
  }
  // 下拉组件 切换下拉项编辑状态
  changeEditDropdownStatus(column?: any) {
    this.isDropdownOptionEdit = !this.isDropdownOptionEdit;
    if (this.isDropdownOptionEdit) {
      this.patchDropdownColumnData(column.id, column);
    }
  }
  // 下拉组件 删除新增选项
  doRemoveDropdownOption(column, option) {
    column.settings.labels = column.settings.labels.filter(label => label.id !== option.id);
    this.dropdownOption = this.dropdownOption.filter(label => label.id !== option.id);
    this.patchDropdownColumnData(column.id, column);
  }
  // 获取下拉项最大ID
  getDropdownOptionId(data) {
    const ids = [];
    if (data) {
      data.forEach((item, index) => {
        ids.push(item.id);
      });
    }
    if (ids.length === 0) {
      return 0;
    } else {
      return ids.reduce((a, b) => {
        return b > a ? b : a;
      });
    }
  }
  // 处理下拉项数据
  handleDropdownOptionList(column) {
    this.dropdownOption = JSON.parse(JSON.stringify(column.settings.labels));
    // 设置无法删除标识
    const userIds = this.getUserIds();
    this.dropdownOption.forEach((item, index) => {
      for (let i = 0; i < userIds.length; i++) {
        if (item.id === userIds[i]) {
          item.notRemove = true;
        }
      }
    });
  }
  // 更新表头数据
  patchDropdownColumnData(columnId?: string, param?: any) {
    this.dataSubscription = this.taskService.doEditColumnHeader(this.boardId, columnId, param).subscribe((res: any) => {
    }, (err) => {
      this.message.create('error', '处理失败！');
    });
  }
  // 更新单元格数据
  patchDropdownPulseData(column) {
    const param = {
      'pulseIds': this.pulseIds,
      'columnId': column.id,
      'columnValue': this.addTaskData[column.id].ids
    };
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
    }, (err) => {
      this.message.create('error', '处理失败！');
    });
  }
  // 获取所有已用ID
  getUserIds() {
    let useIds = [];
    this.boardPulseData.forEach((pulses, index) => {
      for (const item in pulses.columnValues) {
        if (pulses.columnValues.hasOwnProperty(item)) {
          if (pulses.columnValues[this.column.id]) {
            for (let i = 0; i < pulses.columnValues[this.column.id].ids.length; i++) {
              useIds.push(pulses.columnValues[this.column.id].ids[i]);
            }
          }
        }
      }
    });
    useIds = Array.from(new Set(useIds));
    return useIds;
  }
  // 提交数据
  onSubmit() {
    const column = [];
    this.boardColumnData.forEach((item, index) => {
      switch (item.type) {
        case 'date':
          if (this.addTaskData[item.id].date) {
            let dateObj;
            if (!this.dateColumnEnable) {
              dateObj = {
                'columnId': item.id,
                'columnValue': {
                  'date': this.utilsModule.formatDateByGeneral(this.addTaskData[item.id].date)
                }
              };
            } else {
              if (this.addTaskData[item.id]['radioValue'] === 'A') {
                dateObj = {
                  'columnId': item.id,
                  'columnValue': {
                    'date': this.utilsModule.formatDateByGeneral(this.addTaskData[item.id].date),
                    radioValue: 'A'
                  }
                };
              } else {
                dateObj = {
                  'columnId': item.id,
                  'columnValue': {
                    'date': this.addTaskData[item.id].date,
                    radioValue: 'B'
                  }
                };
              }
            }
            column.push(dateObj);
          }
          break;
        case 'date-time':
          if (this.addTaskData[item.id].dateTime) {
            let dateObj;
            if (!this.dateColumnEnable) {
              dateObj = {
                'columnId': item.id,
                'columnValue': {
                  date: this.datePipe.transform(this.addTaskData[item.id].dateTime, 'yyyy-MM-dd'),
                  time: this.datePipe.transform(this.addTaskData[item.id].dateTime, 'HH:mm')
                }
              };
            } else {
              if (this.addTaskData[item.id]['radioValue'] === 'A') {
                dateObj = {
                  'columnId': item.id,
                  'columnValue': {
                    date: this.datePipe.transform(this.addTaskData[item.id].dateTime, 'yyyy-MM-dd'),
                    time: this.datePipe.transform(this.addTaskData[item.id].dateTime, 'HH:mm'),
                    radioValue: 'A'
                  }
                };
              } else {
                dateObj = {
                  'columnId': item.id,
                  'columnValue': {
                    date: this.addTaskData[item.id].dateTime,
                    radioValue: 'B'
                  }
                };
              }
            }
            column.push(dateObj);
          }
          break;
        case 'time-interval':
          let dates = null;
          if (this.addTaskData[item.id].date && this.addTaskData[item.id].date.length > 1) {
            dates = [this.datePipe.transform(this.addTaskData[item.id].date[0], 'yyyy-MM-dd HH:mm'),
              this.datePipe.transform(this.addTaskData[item.id].date[1], 'yyyy-MM-dd HH:mm')];
          }
          if (!this.dateColumnEnable) {
            if (dates) {
              let dateObj;
              dateObj = {
                'columnId': item.id,
                'columnValue': {
                  date: dates
                }
              };
              column.push(dateObj);
            }
          } else {
            let dateObj;
            if (this.addTaskData[item.id]['radioValue'] === 'A') {
              dateObj = {
                'columnId': item.id,
                'columnValue': {
                  date: dates,
                  radioValue: 'A'
                }
              };
            } else {
              dateObj = {
                'columnId': item.id,
                'columnValue': this.addTaskData[item.id]
              };
            }
            column.push(dateObj);
          }
          break;
        case 'status':
          if (this.addTaskData[item.id] && this.addTaskData[item.id].index !== 0) {
            const statusObj = {
              'columnId': item.id,
              'columnValue': this.addTaskData[item.id]
            };
            column.push(statusObj);
          }
          break;
        case 'multiple-person':
          if (this.addTaskData[item.id].personsAndTeams && this.addTaskData[item.id].personsAndTeams.length > 0) {
            const personObj = {
              'columnId': item.id,
              'columnValue': this.addTaskData[item.id]
            };
            column.push(personObj);
          }
          break;
        case 'dropdown':
          if (this.addTaskData[item.id]) {
            const dropdownObj = {
              'columnId': item.id,
              'columnValue': this.addTaskData[item.id]
            };
            column.push(dropdownObj);
          }
          break;
        case 'select':
          if (this.addTaskData[item.id]) {
            const dropdownObj = {
              'columnId': item.id,
              'columnValue': {option: this.addTaskData[item.id]}
            };
            column.push(dropdownObj);
          }
          break;
        default:
          if (this.addTaskData[item.id]) {
            const o = {
              'columnId': item.id,
              'columnValue': this.addTaskData[item.id]
            };
            column.push(o);
          }
          break;
      }
    });
    const data = {
      'pulseIds': this.pulseIds,
      'columnValues': column
    };
    this.nfChangeData.emit(data);
  }
}
